import { apiClient } from "./apiClient";
import type { User } from "@/types/auth";

class AuthApi {
  async me(): Promise<User> {
    const response = await apiClient.get<User>("/v1/auth/me");
    return response.data;
  }
}

export const authApi = new AuthApi();
